<template>
  <div
    class="mobile_vote"
    v-loading.fullscreen.lock="controlLoading"
    :element-loading-text="this.$config.loadingText"
    :element-loading-spinner="this.$config.loadingSpinner"
    :element-loading-background="this.$config.loadingBackground"
  >
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBackProjects()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> {{ projectInfo.ProjectName }} </span>
      <div class="mobile_head_right">
        <a @click="refreshList()">
          <i class="el-icon-refresh"></i>
        </a>
      </div>
    </div>
    <div class="mobile_chair_body" :style="bodyStyle">
      <div class="control_row">
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanBegin"
          @click="startChairScreenVote"
        >
          开始投票
        </el-button>
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanEnd"
          @click="endChairScreenVote"
        >
          结束投票
        </el-button>
      </div>
      <div class="control_row">
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanHigh"
          @click="removeHighScore"
        >
          去掉最高分
        </el-button>
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanCancelHigh"
          @click="cancleRemoveHighScore"
        >
          取消去掉最高分
        </el-button>
      </div>
      <div class="control_row">
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanLow"
          @click="removeLowScore"
        >
          去掉对低分
        </el-button>
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanCancelLow"
          @click="cancleRemoveLowScore"
        >
          取消去掉对低分
        </el-button>
      </div>
      <div class="control_row">
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanResult"
          @click="saveProjectScreenScore"
        >
          计算结果
        </el-button>
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanGroup"
          @click="chairScreenGroupRanking"
        >
          分组排名
        </el-button>
      </div>
      <div class="control_row">
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanTop"
          @click="chairScreenVoteOpenPreviousProject"
        >
          上一项目
        </el-button>
        <el-button
          type="primary"
          class="control_btn"
          :disabled="!projectInfo.IsCanNext"
          @click="chairScreenVoteOpenNextProject"
        >
          下一项目
        </el-button>
      </div>
    </div>
    <div class="mobile_vote_foot">
      <div class="audio_operate_box">
        <el-link
          icon="iconfont icon-playCircle"
          class="audio_operate_btn"
          @click="changeAudio('play')"
        ></el-link>
        <el-link
          icon="iconfont icon-pauseCircle"
          class="audio_operate_btn"
          @click="changeAudio('pause')"
        ></el-link>
        <el-link
          icon="iconfont icon-chongbo"
          class="audio_operate_btn"
          @click="changeAudio('replay')"
        ></el-link>
        <el-popover placement="top" width="260" trigger="click">
          <div
            style="
              display: -webkit-flex;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-around;
              align-items: center;
            "
          >
            <i class="iconfont icon-shengyintianchong"></i>
            <div style="width: 160px">
              <el-slider
                :show-tooltip="false"
                v-model="audioVolume"
                :min="0"
                :max="100"
                @change="changeVolume()"
              ></el-slider>
            </div>
            <span style="width: 30px">{{ audioVolume }}</span>
          </div>
          <el-link
            icon="iconfont icon-shengyintianchong"
            class="audio_operate_btn"
            slot="reference"
          ></el-link>
        </el-popover>
      </div>
      <el-divider direction="vertical"></el-divider>
      <el-link @click="goBackProjects()">返回项目列表</el-link>
    </div>
  </div>
</template>

<script>
import screenApi from '../../../api/mobileVote/screen'
export default {
  data () {
    return {
      controlLoading: true,
      projectInfo: {},
      bodyStyle: {
        marginTop: '45px'
      },
      audioVolume: 100
    }
  },
  methods: {
    getChairScreenControlInfo: function () {
      this.controlLoading = true
      screenApi.getChairScreenControlInfo({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      })
        .then(data => {
          this.projectInfo = data
          this.controlLoading = false
        }).catch(err => {
          this.controlLoading = false
          return err
        })
    },
    startChairScreenVote: function () {
      this.controlLoading = true
      screenApi.startChairScreenVote({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    endChairScreenVote: function () {
      this.controlLoading = true
      screenApi.endChairScreenVote({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    removeHighScore: function () {
      this.controlLoading = true
      screenApi.chairScreenHighestAndLowest({
        voteId: this.$route.params.vid,
        projectId: this.$route.params.pid,
        IsCancelHighest: true
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    cancleRemoveHighScore: function () {
      this.controlLoading = true
      screenApi.chairScreenHighestAndLowest({
        voteId: this.$route.params.vid,
        projectId: this.$route.params.pid,
        IsCancelHighest: false
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    removeLowScore: function () {
      this.controlLoading = true
      screenApi.chairScreenHighestAndLowest({
        voteId: this.$route.params.vid,
        projectId: this.$route.params.pid,
        IsCancelLowest: true
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    cancleRemoveLowScore: function () {
      this.controlLoading = true
      screenApi.chairScreenHighestAndLowest({
        voteId: this.$route.params.vid,
        projectId: this.$route.params.pid,
        IsCancelLowest: false
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    saveProjectScreenScore: function () {
      this.controlLoading = true
      screenApi.saveProjectScreenScore({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    chairScreenGroupRanking: function () {
      this.controlLoading = true
      screenApi.chairScreenGroupRanking({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      }).then(data => {
        this.getChairScreenControlInfo()
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    chairScreenVoteOpenPreviousProject: function () {
      this.controlLoading = true
      screenApi.chairScreenVoteOpenPreviousProject({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      })
        .then(data => {
          // this.$router.push({ name: 'chairScreenControl', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, gid: this.$route.params.gid, pid: data } })
          this.$route.params.pid = data
          this.getChairScreenControlInfo()
        }).catch(err => {
          this.controlLoading = false
          return err
        })
    },
    chairScreenVoteOpenNextProject: function () {
      this.controlLoading = true
      screenApi.chairScreenVoteOpenNextProject({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: this.$route.params.gid,
        projectId: this.$route.params.pid
      })
        .then(data => {
          // this.$router.push({ name: 'chairScreenControl', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, gid: this.$route.params.gid, pid: data } })
          this.$route.params.pid = data
          this.getChairScreenControlInfo()
        }).catch(err => {
          this.controlLoading = false
          return err
        })
    },
    goBackProjects: function () {
      this.$router.push({ name: 'chairScreenProjects', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
    },
    refreshList: function () {
      this.getChairScreenControlInfo()
    },
    changeAudio: function (operate) {
      this.controlLoading = true
      screenApi.screenAudioOperate({
        AudioOperate: operate,
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid
      }).then(data => {
        this.controlLoading = false
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    changeVolume: function () {
      this.controlLoading = true
      screenApi.screenAudioOperate({
        AudioOperate: 'changeVolume',
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        volume: this.audioVolume
      }).then(data => {
        this.controlLoading = false
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    }
  },
  mounted () {
    this.getChairScreenControlInfo()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/mobileVote/vote.css';
.audio_operate_box {
  margin: 0px;
}
.audio_operate_box .audio_operate_btn {
  margin: 0px 10px;
}
.audio_operate_box .audio_operate_btn i {
  font-size: 18px;
  margin: 0px;
}
.audio_operate_box .audio_operate_btn i:active {
  font-size: 22px;
  margin: 0px;
}
</style>
